import moment from 'moment';

const dateUtils = {
      convertToDate(dateStr){
        return this.getStringFromDate(moment(dateStr).toDate());
      },
      getStringFromNewDateFormatDatePick(seperator = '-'){
        let date = new Date();
        return `${this.getBudhaYear(date)}${seperator}${this.formatMonth(date)}${seperator}${this.formatDayPadStart(date)}`;
      },
      getStringFromNewDateFormatDatePick2(seperator = '-') {
        let date = new Date();
        return `${date.getUTCFullYear().toString()}${seperator}${this.formatMonth(date)}${seperator}${this.formatDayPadStart(date)}`;
      },
      getStringDate_Plus2Day(seperator = '-') {
        let date = new Date();
        date.setDate(date.getDate() + 2);
        return `${date.getUTCFullYear().toString()}${seperator}${this.formatMonth(date)}${seperator}${this.formatDayPadStart(date)}`;
      },
      getStringFromDateGetBudhaYear(date, seperator = '/') {
        if (date == null || date == undefined) return '';

        return `${this.formatDayPadStart(date)}${seperator}${this.formatMonth(date)}${seperator}${this.getBudhaYear(date)}`;
      },
      getStringFromDate(date, seperator = '/') {
        if (date == null || date == undefined) return '';

        return `${this.formatDayPadStart(date)}${seperator}${this.formatMonth(date)}${seperator}${date.getUTCFullYear().toString()}`;
      },
      getStringFromDateFormatDatePick(date, seperator = '/') {
        if (date == null || date == undefined) return '';

        return `${this.getBudhaYear(date)}${seperator}${this.formatMonth(date)}${seperator}${this.formatDayPadStart(date)}`;
      },
      getStringFromDatePickFormatDatePick(date, seperator = '-') {
        if (date == null || date == undefined) return '';

        return `${this.getChristianYear(date)}${seperator}${this.formatMonth(date)}${seperator}${this.formatDayPadStart(date)}`;
      },
      getStringFromDatePickFormatDatePick2(date, seperator = '-') {
        if (date == null || date == undefined) return '';

        return `${date.getUTCFullYear().toString()}${seperator}${this.formatMonth(date)}${seperator}${this.formatDayPadStart(date)}`;
      },
      getStringFromDatePickFormatYYYYMM(date, seperator = '-') {
        if (date == null || date == undefined) return '';
    
        return `${date.getUTCFullYear().toString()}${seperator}${this.formatMonth(date)}`;
      },
      getStringFromDatePickFormatYYYY(date) {
        if (date == null || date == undefined) return '';
    
        return `${date.getUTCFullYear().toString()}`;
      },
    
      getStringWithMonthNameFromDate(date, isPadStart = true) {
        if (date == null || date == undefined) return '';

        return `${isPadStart ? this.formatDayPadStart(date) : this.formatDayNoPad(date)} ${this.getMonthByNumber(date)} ${this.getBudhaYear(date)}`;
      },
      getStringWithMonthEnNameFromDate(date, isPadStart = true) {
        if (date == null || date == undefined) return '';

        return `${isPadStart ? this.formatDayPadStart(date) : this.formatDayNoPad(date)} ${this.getMonthEnByNumber(date)} ${date.getUTCFullYear()}`;
      },
    
      getStringWithTimeFromDate(date, seperator = '/') {
        if (date == null || date == undefined) return '';

        return `${this.formatDayPadStart(date)}${seperator}${this.formatMonth(date)}${seperator}${this.getBudhaYear(date)} ${date
          .getHours()
          .toString()
          .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
      },
      getStringWithTimeFromDate2(date, seperator = '/') {
        if (date == null || date == undefined) return '';

        return `${this.formatDayPadStart(date)}${seperator}${this.formatMonth(date)}${seperator}${this.getBudhaYear(date)}_${date
          .getHours()
          .toString()
          .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
      },


      getStringWithTimeFromDateString(dateString, seperator = '/') {
        if (dateString == null || dateString == undefined) return '';

        const date = moment(dateString.toString(), 'DD/MM/YYYY HH:mm:ss').toDate();

        return `${this.formatDayPadStart(date)}${seperator}${this.formatMonth(date)}${seperator}${this.getBudhaYear(date)} ${date
          .getHours()
          .toString()
          .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
      },
    
      diffYears(fromDate, toDate = new Date()) {
        const todayMoment = moment(toDate);
        const currentMoment = moment(fromDate);
        return todayMoment.diff(currentMoment, 'years', true);
      },
    
      formatDayPadStart(date) {
        return date.getDate().toString().padStart(2, '0');
      },
      formatDayNoPad(date) {
        return date.getDate().toString();
      },

      formatMonth(date) {
        return (date.getMonth() + 1).toString().padStart(2, '0');
      },
    
      getMonthByNumber(date) {
        const monthNumber = date.getMonth() + 1;
    
        switch (monthNumber) {
          case 1:
            return 'มกราคม';
          case 2:
            return 'กุมภาพันธ์';
          case 3:
            return 'มีนาคม';
          case 4:
            return 'เมษายน';
          case 5:
            return 'พฤษภาคม';
          case 6:
            return 'มิถุนายน';
          case 7:
            return 'กรกฎาคม';
          case 8:
            return 'สิงหาคม';
          case 9:
            return 'กันยายน';
          case 10:
            return 'ตุลาคม';
          case 11:
            return 'พฤศจิกายน';
          case 12:
            return 'ธันวาคม';
        }
    
        return '';
      },
      getMonthEnByNumber(date) {
        const monthNumber = date.getMonth() + 1;
    
        switch (monthNumber) {
          case 1:
            return 'January';
          case 2:
            return 'February';
          case 3:
            return 'March';
          case 4:
            return 'April';
          case 5:
            return 'May';
          case 6:
            return 'June';
          case 7:
            return 'July';
          case 8:
            return 'August';
          case 9:
            return 'September';
          case 10:
            return 'October';
          case 11:
            return 'November';
          case 12:
            return 'December';
        }
    
        return '';
      },
    
      getBudhaYear(date) {
        return (date.getUTCFullYear() + 543).toString();
      },
      getChristianYear(date) {
        return (date.getUTCFullYear() - 543).toString();
      },
};
export default dateUtils;